/* global gon */
/* global google */

export const placesUri = `https://maps.googleapis.com/maps/api/js?key=${gon.google_places_api_key}&libraries=places&language=${gon.locale}`;

// Define which if the result fields to use
const resultsFieldMapping = {
  subpremise: "short_name",
  street_number: "short_name",
  route: "long_name",
  locality: "long_name",
  administrative_area_level_1: "short_name",
  country: "short_name",
  postal_code: "short_name",
};

export default (input, options = {}) => {
  if (!google || !google.maps || !google.maps.places) {
    console.error(
      "Google Maps JavaScript API with Places library is not loaded.",
    );
    return null;
  }

  const autocompleteOptions = {
    fields: ["address_components", "place_id", "geometry", "name"],
    types: options.types || [],
    componentRestrictions: options.componentRestrictions || options.country || null,
  };

  const autocomplete = new google.maps.places.Autocomplete(
    input,
    autocompleteOptions,
  );

  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();

    if (!place || !place.address_components) {
      console.warn("Autocomplete returned place with no address components.");
      return;
    }

    const { address_components, place_id } = place;

    const components = address_components
      .map((obj) => {
        const valueKey = resultsFieldMapping[obj.types[0]];
        return valueKey ? [obj.types[0], obj[valueKey]] : null;
      })
      .filter(Boolean)
      .reduce((obj, [name, value]) => {
        obj[name] = value;
        return obj;
      }, {});

    if (components.subpremise) {
      components.street_number = [
        components.subpremise,
        components.street_number,
      ].join("/");
    }

    if (components.country) components.country = components.country.toLowerCase();

    if (place_id) components.place_id = place_id;
    input.dispatchEvent(new CustomEvent("geocomplete:result", { detail: components }));
  });

  return autocomplete;
};
